// extracted by mini-css-extract-plugin
export default {"paging_wrapper":"Paging_paging_wrapper__cW1UE"};